import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import { DatePicker } from 'formik-antd';
import { setGuardianshipStatementModalVisibleAction } from 'redux/actions/modal.action';
import Accordion from 'components/Accordion';
import _ from 'lodash';
import { Link } from 'bff/models/link';
import commonService from 'utils/commonService';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
// import PDFViewer from 'components/PDFViewer';
import { Contract, IVehicleOwnerInfoFormValue, IVehicleOwnerInfoState } from 'constants/models/components/insureProcessCar/vehicleOwnerInfo';
import { YesNo } from 'constants/enums/yesNo.enum';
import { SysOption } from 'bff/models/info';
import service from 'bff/services/carProductService';
import memberProfileService from 'bff/services/memberProfileService';
import { CodeId } from 'constants/enums/codeId.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import { VehicleCar, ValidVehiclePolicyPreiodReq } from 'bff/models/product';
import { NationalType } from 'constants/enums/nationalType.enum';
import InputWithRegex from 'components/InputWithRegex';
import { NumAndEnglishRegex } from 'utils/commonValidations';
import storageService from 'utils/storageService';
import { InsType } from 'constants/enums/insType.enum';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import SelectInsuranceTypeModal from 'components/SelectInsuranceTypeModal';
import apiCommonService from 'bff/services/commonService';
import FormikFocusError from 'components/FormikFocusError';
import { IdInfoType } from 'constants/enums/idInfoType.enum';
import { RootReducersState } from 'redux/reducers';
import PDFAllPageViewer from 'components/PDFAllPageViewer';
import AES from 'crypto-js/aes';
import { VehRegReq } from 'bff/models/info/infoVehregdata';

const initFormVal: IVehicleOwnerInfoFormValue = {
  NATIONALITY_TYPE: NationalType.National,
  MEMBER_ID: '',
  BIRTHDAY: '',
  VEHICLE_TYPE: '',
  VEHICLE_TYPE_NAME: '',
  LICENSE_PLATE_NUMBER_FRONT: '',
  LICENSE_PLATE_NUMBER_BACK: '',
  PROGRAM_ID: '',
  DECLARED: '',
  CONTRACTS: new Array(0),
  ALL_CONTRACT_CHECKED: false
};

let formInitialValues = initFormVal;

const formValidationSchema = Yup.object().shape({
  NATIONALITY_TYPE: Yup.string().required('此為必填欄位'),
  MEMBER_ID: Yup.string().required('此為必填欄位').when('NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
    if (nationalityType === NationalType.National) {
      return schema.length(10, '身份證長度為 10 字元').matches(/^[A-Z]\d{9}$/, '身份證格式不符');
    }
    if (nationalityType === NationalType.Foreigner) {
      return schema.length(10, '居留證長度為 10 字元');
    }

    return schema.length(8, '統一編號長度為 8 字元').matches(/^\d{8}$/, '統一編號格式不符');
  }),
  BIRTHDAY: Yup.string().when('NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
    if (nationalityType && nationalityType !== NationalType.Legal) {
      return schema.required('此為必填欄位').nullable();
    }
  }),
  VEHICLE_TYPE: Yup.string().required('此為必填欄位'),
  LICENSE_PLATE_NUMBER_FRONT: Yup.string().required('此為必填欄位').max(4, '最大為 4 字元'),
  LICENSE_PLATE_NUMBER_BACK: Yup.string().required('此為必填欄位').max(4, '最大為 4 字元'),
  DECLARED: Yup.string().required('此為必填欄位')
});

const initState: IVehicleOwnerInfoState = {
  activeNationalityType: '',
  isDeclared: false,
  docLinks: new Array(0),
  yesnoSysOpts: new Array(0),
  flows: new Array(0),
  policyPeriodRes: {
    VEHICLE_PNO: '',
    VEHICLE_OWNER_ID: '',
    COMPULSORY_EXP_STATUS: '',
    VOLUNTARY_EXP_STATUS: '',
    COMPULSORY_SDATE: '',
    VOLUNTARY_SDATE: '',
    VOLUNTARY_EDATE: '',
    COMPULSORY_EDATE: '',
    VOWNER_BIRTHDAY: ''
  },
  memberIdErrMsg: '',
  isNaturalPerson: false,
  termStatus: new Array(0),
  carrmCodes: new Array(0)
};

/** 合理範圍的生日日期 */
const validBirthDay = new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate());

class InsureProcessVehicleOwnerInfo extends React.Component<IProps, IVehicleOwnerInfoState> {
  private formikRef: any = React.createRef();

  state: IVehicleOwnerInfoState = initState;

  componentDidMount = async () => {
    commonService.scrollToTop();
    if (this.props.fetchFavoriteComplete) {
      sweetAlertService.modal({
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W051)
      });
    }
    // console.log('tempVehicleOwnerInfo', this.props.tempVehicleOwnerInfo);
    if (this.props.tempVehicleOwnerInfo &&
      this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue &&
      this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoState) {
      this.handleInitTempData();
      return;
    }

    await this.handleInitData();
  }

  componentDidUpdate (prevProps: IProps, prevState: IVehicleOwnerInfoState) {
    if (!prevProps.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue && this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue) {
      this.handleInitTempData();
    }
    // console.log('componentDidUpdate InsureProcessVehicleOwnerInfo', this.state);
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    let formVal = this.formikRef.current.values;
    formVal = {
      ...formVal,
      BIRTHDAY: this.state.activeNationalityType === NationalType.Legal
        ? ''
        : formVal.BIRTHDAY
    };

    // this.props.setSelectInsuranceTypeModalVisible(false);
    this.props.onUnmount(formVal, this.state);

    formInitialValues = {
      ...initFormVal
    };
  }

  /**
   * @description 取得要保人聲明事項初始值
  */
  handleGetContracts = (contractLinks: Link[]) => {
    const res = new Array(0);
    if (contractLinks && contractLinks.length > 0) {
      _.forEach(contractLinks, (contractLink: Link, index: number) => {
        res.push({
          LINK_NAME: contractLink.NAME,
          LINK_URL: contractLink.URL,
          CONTRACT: false
        });
      });
    }
    return res;
  }

  /**
   * @description 若有暫存資料，帶入暫存資料
  */
  handleInitTempData = () => {
    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
    formInitialValues = {
      ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue,
      PROGRAM_ID: tempVehicleOwnerInfoFormValue && tempVehicleOwnerInfoFormValue.PROGRAM_ID ? tempVehicleOwnerInfoFormValue.PROGRAM_ID : this.props.programId
    } as IVehicleOwnerInfoFormValue;
    this.setState({ ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoState as IVehicleOwnerInfoState });
  }

  /**
   * @description 初始化頁面資料
  */
  handleInitData = async () => {
    const initSetting = await service.fetchInitVehicleOwnerInfo(this.props.insTypeId as InsType);
    const contracts = this.handleGetContracts(initSetting.docLinks);

    formInitialValues = {
      ...formInitialValues,
      CONTRACTS: contracts,
      PROGRAM_ID: this.props.programId,
      // 若有續保資料則帶入
      NATIONALITY_TYPE: this.props.renewalInfo?.INSURED_DATA.DATA[0].INSURED_ID_TYPE ?? '',
      MEMBER_ID: this.props.renewalInfo?.INSURED_DATA.DATA[0].ID ?? '',
      BIRTHDAY: this.props.renewalInfo?.INSURED_DATA.DATA[0].INSURED_BIRTHDAY ?? '',
      VEHICLE_TYPE: this.props.renewalInfo?.VEHICLE_DATA.VEHICLECAT_ID ?? '',
      VEHICLE_TYPE_NAME: `${this.props.renewalInfo?.VEHICLE_DATA.VEHICLECAT_ID ?? ''}${this.props.renewalInfo?.VEHICLE_DATA.VEHICLENAME ?? ''}`,
      LICENSE_PLATE_NUMBER_FRONT: this.props.renewalInfo?.VEHICLE_DATA.CAR_LICENSE.split('-')[0] ?? '',
      LICENSE_PLATE_NUMBER_BACK: this.props.renewalInfo?.VEHICLE_DATA.CAR_LICENSE.split('-')[1] ?? ''
    };

    this.setState({
      docLinks: [...initSetting.docLinks],
      yesnoSysOpts: [...initSetting.yesnoSysOpts],
      flows: [...initSetting.flows],
      carrmCodes: [...initSetting.carrmCodes],
      activeNationalityType: NationalType.National,
      isNaturalPerson: this.handleCheckNaturalPerson(NationalType.National),
      termStatus: commonService.getInitTermStatus(contracts)
    });
  }

  /**
    * @description 根據路徑下載檔案
   */
  handleDownloadFile = (event: React.MouseEvent<HTMLButtonElement>, linkUrl: string, fileName: string) => {
    event.stopPropagation();
    try {
      commonService.downloadFile(linkUrl, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  };

  /**
    * @description 檢核帳號是否已存在格式是否正確
    */
  handleValidID = _.debounce(async (val: any, nationalityType: string) => {
    if (!this.formikRef || !this.formikRef.current) return;
    // console.log('val', val);
    // console.log('nationalityType', nationalityType);
    let errorVal;
    const setFieldError = this.formikRef.current.setFieldError;
    const isNaturalValid = this.handleCheckNaturalPerson(nationalityType) &&
      val.length === 10;

    if (isNaturalValid) {
      errorVal = await memberProfileService.validMemberId(val, nationalityType).then((res: any) => res.ID);
      setFieldError('MEMBER_ID', errorVal);

      this.setState({ memberIdErrMsg: errorVal });
      this.props.onResetTempData();
    }

    const isLegalValid = !this.handleCheckNaturalPerson(nationalityType) && val.length === 8;
    if (isLegalValid) {
      errorVal = await memberProfileService.validMemberId(val, nationalityType).then((res: any) => res.ID);
      setFieldError('MEMBER_ID', errorVal);

      this.setState({ memberIdErrMsg: errorVal });
      this.props.onResetTempData();
    }

    // if (errorVal || (!isNaturalValid && !isLegalValid)) return;

    // this.props.setSelectInsuranceTypeModalVisible(true, val, nationalityType);
  }, 500);

  /**
   * 機車險-檢核輸入生日是否正確
   */
  handleValidMotoBirthday = async (nationality: string, memberId: string, birthday: any) => {
    // 判斷是否為會員
    const validMemberRes = await memberProfileService.validMember(memberId);
    if (!validMemberRes) return;

    const req = {
      MEMBER_ID: memberId,
      BIRTHDAY: moment(birthday).format('YYYYMMDD')
    };

    // 是會員呼叫檢核生日 API
    const birthdayErrMsg = await service.validMotoBirthday(req);
    if (birthdayErrMsg) return commonService.getCodeMsg(this.props.UICodes, CodeId.W045);
  }

  /**
  * @description 汽車險-檢核輸入生日是否正確
  */
  handleValidCarBirthday = async (memberId: string, birthday: any, vehicleType: string) => {
    const req = {
      ID: memberId,
      VEHICLE_TYPE: '03',
      CARRY_LIMIT: '5', // 承載數量
      CARRY_FLAG: 'P', // 承載單位：P:人 T:噸
      BIRTHDAY: moment(birthday).format('YYYYMMDD'),
      SEX: this.handleGetMemberSex(memberId) // 性別：1:男 2:女
    };

    const birthdayErrMsg = await service.validCarBirthday(req);
    if (birthdayErrMsg) return commonService.getCodeMsg(this.props.UICodes, CodeId.W045);

    // const isSame = moment(moment(birthday).format('YYYYMMDD')).isSame(moment(moment(periodBirthday).format('YYYYMMDD')));

    // if (!isSame) {
    //   return '生日檢核錯誤，請重新輸入';
    // }
  }

  /**
   * @description 取得車主性別
   */
  handleGetMemberSex = (memberId: string) => {
    switch (memberId[1]) {
      // 本國人、外國人男性
      case IdInfoType.NationalMale:
      case IdInfoType.ForeignMale:
      case IdInfoType.ResidentMale:
      case IdInfoType.ResidentStatelessMale:
        return '1';
      // 本國人、外國人女性
      case IdInfoType.NationalFemale:
      case IdInfoType.ForeignFemale:
      case IdInfoType.ResidentFemale:
      case IdInfoType.ResidentStatelessFemale:
        return '2';
      default:
        return '';
    }
  }

  /**
  * @description 表單 Submit 事件
  */
  handleFormSubmit = async (values: IVehicleOwnerInfoFormValue, action: any) => {
    if (this.formikRef && this.formikRef.current && this.formikRef.current.dirty) {
      this.handleFormOnChange(this.formikRef.current.dirty);
    }

    const storageKey = this.props.insTypeId === InsType.Car ? storageKeys.CarProgramCode : storageKeys.MotoProgramCode;
    storageService.removeItem(storageKey);

    // 如有填入專案代碼，判斷專案代碼是否存在
    if (values.PROGRAM_ID) {
      const res = await apiCommonService.verifyProgramId(values.PROGRAM_ID, this.props.insTypeId);

      if (typeof res === 'string') {
        this.formikRef.current.setFieldError('PROGRAM_ID', res);
        return;
      }

      if (res && res.PROGRAM_ID) {
        // console.log('PROGRAM_ID', res.PROGRAM_ID);

        storageService.setItem(storageKey, res.PROGRAM_ID);
      }
    }

    let birthdayErrMsg;
    // 機車險檢核生日
    if (!this.state.policyPeriodRes.VEHICLE_OWNER_ID && this.props.insTypeId === InsType.Moto && values.NATIONALITY_TYPE !== NationalType.Legal) {
      birthdayErrMsg = await this.handleValidMotoBirthday(values.NATIONALITY_TYPE, values.MEMBER_ID, values.BIRTHDAY);
    }

    // 汽車險檢核生日
    if (!this.state.policyPeriodRes.VEHICLE_OWNER_ID && this.props.insTypeId === InsType.Car && values.NATIONALITY_TYPE !== NationalType.Legal) {
      birthdayErrMsg = await this.handleValidCarBirthday(values.MEMBER_ID, values.BIRTHDAY, values.VEHICLE_TYPE);
    }

    if (birthdayErrMsg) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: birthdayErrMsg
      });

      return;
    }

    let state = { ...this.state };
    if (!this.state.policyPeriodRes.VEHICLE_OWNER_ID) {
      const licenseNum = `${values.LICENSE_PLATE_NUMBER_FRONT}-${values.LICENSE_PLATE_NUMBER_BACK}`;
      const policyPeriodRes = await this.handleValidPolicyPeriod(values.NATIONALITY_TYPE, values.MEMBER_ID, licenseNum);
      if (!policyPeriodRes) return;

      state = {
        ...state,
        policyPeriodRes: { ...policyPeriodRes }
      };
    }

    const formVal: IVehicleOwnerInfoFormValue = {
      ...values,
      BIRTHDAY: this.state.activeNationalityType === NationalType.Legal
        ? ''
        : values.BIRTHDAY
    };

    // 移到 setState() 前面，確保下一頁可正常讀取 (2025/02/07)
    // 清除緩存
    storageService.removeItem(storageKeys.Vehregdata);
    // 若相關欄位皆檢核通過，於進到下一頁前緩存上行電文，否則不執行緩存，後續亦不會觸發查詢核心資料
    const liceseNo = `${values.LICENSE_PLATE_NUMBER_FRONT}-${values.LICENSE_PLATE_NUMBER_BACK}`;
    await this.saveVehregdataReq(values.MEMBER_ID, values.VEHICLE_TYPE, liceseNo, values.BIRTHDAY);

    this.setState({ ...state });

    //  console.log('formVal', formVal);
    await this.props.onVehicleOwnerInfoSubmit(formVal, state);
  }

  /**
   * @description 執行關貿檢核
   * @param nationalityType 身份別
   * @param memberId 會員 ID
   * @param licenseNum 車牌號碼
  */
  handleValidPolicyPeriod = async (nationalityType: string, memberId: string, licenseNum: string) => {
    const req: ValidVehiclePolicyPreiodReq = {
      INS_TYPE_ID: this.props.insTypeId,
      ID_TYPE: nationalityType,
      VEHICLE_PNO: licenseNum,
      VEHICLE_OWNER_ID: memberId
    };

    return await service.validVehiclePolicyPeriod(req);
  }

  /**
   * @description 產生是否受監護宣告區塊
  */
  handleCreateDelcareArea = (values: IVehicleOwnerInfoFormValue, errors: any) => {
    if (!this.state.yesnoSysOpts || this.state.yesnoSysOpts.length === 0) return;

    return _.map(this.state.yesnoSysOpts, (sysOpt: SysOption, index: number) => {
      return (
        <div className="element__radio-group" key={index}>
          <label htmlFor={`declared-radio-${sysOpt.PARAM_VALUE}`}>
            <div className="element__radio">
              <Field
                type="radio"
                name="DECLARED"
                id={`declared-radio-${sysOpt.PARAM_VALUE}`}
                value={sysOpt.PARAM_VALUE}
                disabled={Boolean(this.state.memberIdErrMsg) || Boolean(errors.MEMBER_ID) || !values.MEMBER_ID}
                onClick={(e: React.MouseEvent<HTMLInputElement>) => this.setState({ isDeclared: e.currentTarget.value === YesNo.Yes })}
              />
              <div className="element__radio-btn" />
            </div>
            <span>{sysOpt.PARAM_TEXT}</span>
          </label>
        </div>
      );
    });
  }

  /**
   * @description 建立相關條款文件內容區塊
  */
  handleCreateContractArea = (values: IVehicleOwnerInfoFormValue, errors: any) => {
    if (!this.state.docLinks || this.state.docLinks.length === 0) return;

    const child = _.map(this.state.docLinks, (docLink: Link, index: number) => {
      return (
        <Accordion.Item
          key={index}
          updateStatus={(openVal: any) => {
            // 更新條款狀態
            this.setState({
              termStatus: commonService.headerClickUpdateTermStatus(openVal, index, this.state.termStatus)
            });
          }}
          isActive={commonService.setPDFOpen(index, this.state.termStatus)}
        >
          {docLink.URL.includes('.pdf') ? (
            <Accordion.Header title={docLink.NAME}>
              <button
                type="button"
                disabled={this.state.isDeclared || Boolean(this.state.memberIdErrMsg) || Boolean(errors.MEMBER_ID) || !values.MEMBER_ID}
                className="review-terms__download-btn"
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => this.handleDownloadFile(event, docLink.URL, docLink.NAME)}
              />
            </Accordion.Header>
          ) : (
            <Accordion.Header title={docLink.NAME} link={docLink.URL} />
          )}
          <Accordion.Content>
            {docLink.URL.includes('.pdf') && (
              <PDFAllPageViewer
                url={docLink.URL}
                show={commonService.setPDFOpen(index, this.state.termStatus) || false}
                updateStatus={(bottom: any) => {
                // 更新條款狀態
                  this.setState((prev: any) => ({
                    ...prev,
                    termStatus: commonService.headerScrollUpdateTermStatus(bottom, index, this.state.termStatus)
                  }));
                }}
                checkContracts={!this.state.memberIdErrMsg && !errors.MEMBER_ID && values.MEMBER_ID && values.DECLARED !== YesNo.Yes ? () => {
                  this.formikRef.current.setFieldValue(`CONTRACTS[${index}].CONTRACT`, true);
                  apiCommonService.fetchSysTime().then((res: any) => {
                    this.formikRef.current.setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, res);
                  });
                } : () => {}}
              />
            )}
          </Accordion.Content>
          <Accordion.Addition>
            <div className="element__checkbox-group">
              <label htmlFor={`statement-checkbox${index + 1}`}>
                <div className="element__checkbox">
                  <Field
                    disabled={this.state.isDeclared || Boolean(this.state.memberIdErrMsg) || Boolean(errors.MEMBER_ID) || !values.MEMBER_ID || commonService.setPDFCheckable(index, this.state.termStatus)}
                    type="checkbox"
                    name={`CONTRACTS[${index}].CONTRACT`}
                    id={`statement-checkbox${index + 1}`}
                    onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                      if (e.currentTarget.checked) {
                        apiCommonService.fetchSysTime().then((res: any) => {
                          this.formikRef.current.setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, res);
                        });
                      }

                      if (!e.currentTarget.checked) {
                        this.formikRef.current.setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, null);
                        this.formikRef.current.setFieldValue('ALL_CONTRACT_CHECKED', false);
                        this.formikRef.current.setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
                      }

                      // 更新條款狀態
                      this.setState({
                        termStatus: commonService.updateTermStatus(e.currentTarget.checked, index, this.state.termStatus)
                      });
                    }}
                  />
                  <div className="element__checkbox-btn" />
                </div>
                <span>審閱條款</span>
              </label>
            </div>
          </Accordion.Addition>
        </Accordion.Item>
      );
    });
    return (
      <Accordion>
        {child}
      </Accordion>
    );
  }

  /**
   * @description 檢核車牌號碼
   */
  handleLicensePlate = (vehicleType: string) => {
    if (!vehicleType) return;

    const vehicle = _.find(this.props.vehicleCars, (vehicle: VehicleCar) => vehicle.VEHICLECAT_ID === vehicleType);
    if (!vehicle) return;

    const frontEle = document.querySelector("input[data-fieldname='LICENSE_PLATE_NUMBER_FRONT']") as HTMLInputElement;
    const backEle = document.querySelector("input[data-fieldname='LICENSE_PLATE_NUMBER_BACK']") as HTMLInputElement;
    if (!frontEle || !backEle) return;

    const plateNum = `${frontEle.value}-${backEle.value}`;

    const regex = new RegExp(vehicle.PNO_FORMAT);
    return regex.test(plateNum)
      ? ''
      : '輸入的車牌有誤';
  }

  /**
   * @description 判斷是否為自然人
   */
  handleCheckNaturalPerson = (nationalityType: string) => {
    return nationalityType === NationalType.National || nationalityType === NationalType.Foreigner;
  }

  /**
   * @description 身份別切換事件
   */
  handleNationalityTypeChange = (e: React.MouseEvent<HTMLInputElement>, memberId: string, nationalityType: string, resetForm: any, setFieldValue: any) => {
    const isNaturalPerson = this.state.isNaturalPerson;
    const newIsNaturalPerson = this.handleCheckNaturalPerson(e.currentTarget.value);
    this.setState({ activeNationalityType: e.currentTarget.value, isNaturalPerson: newIsNaturalPerson });

    // 自然人/法人 互相切換
    if (isNaturalPerson !== newIsNaturalPerson) {
      resetForm({
        values: {
          ...initFormVal,
          NATIONALITY_TYPE: e.currentTarget.value,
          CONTRACTS: this.handleGetContracts(this.state.docLinks)
        }
      });
      this.props.onResetTempData();
      return;
    }

    // 身份別切換檢核 ID
    if (nationalityType !== e.currentTarget.value) {
      this.handleValidID(memberId, e.currentTarget.value);
      setFieldValue('VEHICLE_TYPE', '');
      setFieldValue('VEHICLE_TYPE_NAME', '');
    }
  }

  /**
   * @description 表單 onChange 事件，清除關貿保期與暫存資料
   */
  handleFormOnChange = (dirty: boolean) => {
    if (dirty && this.state.policyPeriodRes.VEHICLE_OWNER_ID) {
      const { tempVehicleInfoFormValue, tempVehicleInfoState } = this.props.tempVehicleInfo;
      if (tempVehicleInfoFormValue || tempVehicleInfoState) {
        this.props.onResetTempVehicleInfo();
      }
      this.setState(prevState => {
        return {
          ...prevState,
          policyPeriodRes: { ...initState.policyPeriodRes }
        };
      });
    }
  }

  /**
   * @description 緩存查詢核心車籍資料的上行電文
   * @param id (自然人) 身份證字號/居留證號、(法人) 統一編號
   * @param vehicleType 車種
   * @param licenseNo 車牌號碼
   * @param birthday 生日
   */
  saveVehregdataReq = async (id: string, vehicleType: string, licenseNo: string, birthday?: string) => {
    // 檢核身份證字號格式，第二碼僅允許 1、2 兩個數字
    if (this.state.activeNationalityType === NationalType.National) {
      if (id.length !== 10 || !id.match(/^[A-Z]{1}[1-2]{1}[0-9]{8}$/)) return;
    }
    // 檢核居留證號格式
    // 擴充新式居留證規則 (2025/02/25)
    if (this.state.activeNationalityType === NationalType.Foreigner) {
      if (id.length !== 10 || !id.match(/^[A-Z]{1}[A-D]{1}[0-9]{8}$|^[A-Z]{1}[8-9]{1}[0-9]{8}$/)) return;
    }
    // 檢核統一編號格式
    if (this.state.activeNationalityType === NationalType.Legal) {
      if (id.length !== 8) return;
    }
    const result = await memberProfileService.validMemberId(id, this.state.activeNationalityType);
    if (result.ID) {
      return;
    }
    // 若為自然人，則生日不可為空值
    if (
      this.state.activeNationalityType === NationalType.National ||
      this.state.activeNationalityType === NationalType.Foreigner
    ) {
      if (!birthday) return;
    }
    // 檢核車種
    if (!vehicleType) return;
    // 依據車種，檢核車牌號碼格式是否合法
    const vehicle = _.find(this.props.vehicleCars, (vehicle: VehicleCar) => vehicle.VEHICLECAT_ID === vehicleType);
    if (!vehicle) return;
    const regex = new RegExp(vehicle.PNO_FORMAT);
    if (!licenseNo || !regex.test(licenseNo)) return;
    // 若前面必填資料未通過檢核，則後面步驟「不執行」查詢核心資料流程，若檢核成功，則緩存加密的上行電文
    const dataItem: VehRegReq = {
      INS_TYPE_ID: this.props.insTypeId,
      SEQ: '01',
      ID: id,
      LICENSENO: licenseNo,
      BIRTHDAY: birthday ? moment(birthday).format('YYYY-MM-DD') : '',
      CARKINDCODE: vehicleType
    };
    const ciphertext = AES.encrypt(JSON.stringify(dataItem), 'vehicle core protection').toString();
    storageService.setItem(storageKeys.Vehregdata, ciphertext);
  }

  render () {
    /**
     * @description 取得會員 ID 類別對應的顯示名稱
    */
    const handleGetMemberIdType = () => {
      switch (this.state.activeNationalityType) {
        case NationalType.Foreigner:
          return '居留證號';
        case NationalType.Legal:
          return '統一編號';
        case NationalType.National:
        default:
          return '身份證字號';
      }
    };

    /**
     * @description 取得生日 類別對應的顯示名稱
    */
    const handleGetBirthdayType = () => {
      switch (this.state.activeNationalityType) {
        case NationalType.National:
        case NationalType.Foreigner:
        default:
          return '生日';
        case NationalType.Legal:
          return '公司登記日期';
      }
    };

    // #region 產生可用車輛種類下拉選單
    let vehicleCarOpts: any;
    if (this.props.vehicleCars && this.props.vehicleCars.length > 0) {
      vehicleCarOpts = _.map(this.props.vehicleCars, (vehicleCar: VehicleCar, index: number) => {
        if (vehicleCar.PTYPE_APPLICABLE && vehicleCar.PTYPE_APPLICABLE.indexOf(this.state.activeNationalityType) === -1) return;
        return <option value={vehicleCar.VEHICLECAT_ID} key={index}>{`${vehicleCar.VEHICLECAT_ID}${vehicleCar.VEHICLECAT_NAME}`}</option>;
      });
    }
    // #endregion
    return (
      <div className="insure-process-vehical-owner-info">
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={this.handleFormSubmit}
          innerRef={this.formikRef}
          enableReinitialize
        >
          {({ errors, touched, setFieldValue, setFieldTouched, handleChange, resetForm, values, dirty }) => (
            <Form
              onChange={() => { this.handleFormOnChange(dirty); }}
            >
              <div className="insure-process-vehical-owner-info__content">
                {/* 車主基本資料 */}
                <div className="vehical-owner-info">
                  <div className="vehical-owner-info__title">車主基本資料</div>
                  <div className="vehical-owner-info__content">
                    <div className="vehical-owner-info__row">
                      {/* 身份別 */}
                      <div className={'element__form-group' + (errors.NATIONALITY_TYPE && touched.NATIONALITY_TYPE ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-title">證件類別*</div>
                        <div className="element__form-group-content">
                          {
                            this.props.nationalityVSysOpts && this.props.nationalityVSysOpts.length > 0 && _.map(this.props.nationalityVSysOpts, (sysOpt: SysOption, index: number) => {
                              return (
                                <div className="element__radio-group" key={index}>
                                  <label htmlFor={`native-radio-${sysOpt.PARAM_VALUE}`}>
                                    <div className="element__radio">
                                      <Field
                                        type="radio" disabled={this.state.isDeclared}
                                        name="NATIONALITY_TYPE" id={`native-radio-${sysOpt.PARAM_VALUE}`}
                                        value={sysOpt.PARAM_VALUE}
                                        onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                          this.handleNationalityTypeChange(e, values.MEMBER_ID, values.NATIONALITY_TYPE, resetForm, setFieldValue);
                                        }}
                                      />
                                      <div className="element__radio-btn" />
                                    </div>
                                    <span>{sysOpt.PARAM_TEXT}</span>
                                  </label>
                                </div>
                              );
                            })
                          }
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="NATIONALITY_TYPE" />
                        </div>
                      </div>
                    </div>
                    <div className="vehical-owner-info__row">
                      {/* 身份證字號 */}
                      <div className={'element__form-group' + (errors.MEMBER_ID && touched.MEMBER_ID ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-title">{handleGetMemberIdType()}* <span className="vehical-owner-info__highlight-text">{commonService.getCodeMsg(this.props.UICodes, CodeId.W052)}</span> </div>
                        <Field
                          type="text"
                          disabled={this.state.isDeclared}
                          name="MEMBER_ID"
                          data-fieldname="MEMBER_ID"
                          tabIndex={1}
                          className="element__input"
                          autoComplete="off"
                          maxLength={10}
                          validate={() => this.state.memberIdErrMsg}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
                            setFieldTouched('MEMBER_ID', true);
                            handleChange('MEMBER_ID')(e);
                            setFieldValue('MEMBER_ID', val);
                          }}
                        />
                        <p className="vehical-owner-info__highlight-text">{commonService.getCodeMsg(this.props.UICodes, CodeId.U030)}</p>
                        <div className="element__error-message">
                          <ErrorMessage name="MEMBER_ID" />
                        </div>
                      </div>
                    </div>
                    {/* 生日 */}
                    <div className="vehical-owner-info__row">
                      {
                        this.state.activeNationalityType !== NationalType.Legal && (
                          <div className={'element__form-group' + (errors.BIRTHDAY && touched.BIRTHDAY ? ' element__form-group--invalid' : '')}>
                            <div className="element__form-group-title">{handleGetBirthdayType()}*<span className="ant-picker-exam-info">範例： 20200101</span></div>
                            <DatePicker
                              name="BIRTHDAY"
                              disabledDate={(current: any) => {
                                // 車主生日
                                return current && (current > moment().add(-18, 'y') || current < moment('1911/01/01'));
                                // return current && (current > moment(validBirthDay) || current < moment('1911/01/01'));
                              }}
                              data-fieldname="BIRTHDAY"
                              tabIndex={2}
                              className="element__input"
                              format="YYYYMMDD"
                              showToday={false}
                              disabled={this.state.isDeclared || Boolean(this.state.memberIdErrMsg) || Boolean(errors.MEMBER_ID) || !values.MEMBER_ID}
                              // defaultPickerValue={moment(validBirthDay)}
                              defaultPickerValue={moment().add(-18, 'y')}
                            />
                            <div className="element__error-message">
                              <ErrorMessage name="BIRTHDAY" />
                            </div>
                          </div>
                        )
                      }
                    </div>
                    <div className="vehical-owner-info__row">
                      {/* 車輛種類 */}
                      <div className={'element__form-group' + (errors.VEHICLE_TYPE && touched.VEHICLE_TYPE ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-title">車輛種類*</div>
                        <Field
                          as="select"
                          disabled={this.state.isDeclared || Boolean(this.state.memberIdErrMsg) || Boolean(errors.MEMBER_ID) || !values.MEMBER_ID}
                          name="VEHICLE_TYPE"
                          data-fieldname="VEHICLE_TYPE"
                          tabIndex={3}
                          className="element__select"
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            commonService.setSelectOptName(setFieldValue, 'VEHICLE_TYPE_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                            if (e.target.value === '04' || e.target.value === '19') sweetAlertService.info('', commonService.getCodeMsg(this.state.carrmCodes, CodeId.CARRM07));
                            handleChange('VEHICLE_TYPE')(e);
                          }}
                        >
                          <option value="">請選擇</option>
                          {vehicleCarOpts}
                        </Field>
                        <p className="vehical-owner-info__highlight-text">{commonService.getCodeMsg(this.props.UICodes, CodeId.U024)}</p>
                        <div className="element__error-message">
                          <ErrorMessage name="VEHICLE_TYPE" />
                        </div>
                      </div>
                    </div>
                    <div className="vehical-owner-info__row license">
                      {/* 車牌號碼 */}
                      <div className={'element__form-group' + ((errors.LICENSE_PLATE_NUMBER_FRONT && touched.LICENSE_PLATE_NUMBER_FRONT) || (errors.LICENSE_PLATE_NUMBER_BACK && touched.LICENSE_PLATE_NUMBER_BACK) ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-title">車牌號碼*</div>
                        <div className="element__form-group-content">
                          <Field
                            component={InputWithRegex}
                            regex={NumAndEnglishRegex}
                            disabled={this.state.isDeclared || Boolean(this.state.memberIdErrMsg) || Boolean(errors.MEMBER_ID) || !values.MEMBER_ID}
                            name="LICENSE_PLATE_NUMBER_FRONT"
                            data-fieldname="LICENSE_PLATE_NUMBER_FRONT"
                            tabIndex={4}
                            className="element__input element__input-limit"
                            autoComplete="off"
                            maxLength={4}
                            onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                              setFieldTouched('LICENSE_PLATE_NUMBER_FRONT', true);
                            }}
                            validate={(val: any) => {
                              if (val && values.LICENSE_PLATE_NUMBER_BACK) {
                                return this.handleLicensePlate(values.VEHICLE_TYPE);
                              }
                              return '';
                            }}
                            onChange={(val: any) => {
                              handleChange(val);
                              setFieldValue('LICENSE_PLATE_NUMBER_FRONT', val.toUpperCase());
                            }}
                          />
                          <hr />
                          <Field
                            component={InputWithRegex}
                            regex={NumAndEnglishRegex}
                            disabled={this.state.isDeclared || Boolean(this.state.memberIdErrMsg) || Boolean(errors.MEMBER_ID) || !values.MEMBER_ID}
                            name="LICENSE_PLATE_NUMBER_BACK"
                            data-fieldname="LICENSE_PLATE_NUMBER_BACK"
                            tabIndex={5}
                            className="element__input element__input-limit"
                            autoComplete="off"
                            maxLength={4}
                            onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                              setFieldTouched('LICENSE_PLATE_NUMBER_BACK', true);
                            }}
                            validate={(val: any) => {
                              if (val && values.LICENSE_PLATE_NUMBER_FRONT) {
                                return this.handleLicensePlate(values.VEHICLE_TYPE);
                              }
                              return '';
                            }}
                            onChange={(val: any) => {
                              handleChange(val);
                              setFieldValue('LICENSE_PLATE_NUMBER_BACK', val.toUpperCase());
                            }}
                          />
                        </div>
                        <div className="element__error-message">
                          {
                            (errors.LICENSE_PLATE_NUMBER_FRONT && touched.LICENSE_PLATE_NUMBER_FRONT)
                              ? errors.LICENSE_PLATE_NUMBER_FRONT
                              : (errors.LICENSE_PLATE_NUMBER_BACK && touched.LICENSE_PLATE_NUMBER_BACK)
                                ? errors.LICENSE_PLATE_NUMBER_BACK
                                : ''
                          }
                        </div>
                      </div>
                      <div className={`license-plate${this.props.prodId.includes('E') ? ' ecar' : ''}`}>
                        <div className="screw-hole screw-hole-1" />
                        <div className="screw-hole screw-hole-2" />
                        <div className="no-container no-container-1">
                          <p className="no">{values.LICENSE_PLATE_NUMBER_FRONT}</p>
                        </div>
                        <div className="dash-container"><span className="dash">-</span></div>
                        <div className="no-container no-container-2">
                          <p className="no">{values.LICENSE_PLATE_NUMBER_BACK}</p>
                        </div>
                      </div>
                    </div>
                    <div className="vehical-owner-info__row">
                      {/* 專案代碼 */}
                      <div className={'element__form-group' + (errors.PROGRAM_ID ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-title">活動代碼/推薦員編  <span>{commonService.htmlParser(commonService.getCodeMsg(this.props.UICodes, CodeId.U044))}</span> </div>
                        <Field
                          autoComplete="off"
                          type="text"
                          disabled={this.state.isDeclared || Boolean(this.state.memberIdErrMsg) || Boolean(errors.MEMBER_ID) || !values.MEMBER_ID}
                          name="PROGRAM_ID"
                          data-fieldname="PROGRAM_ID"
                          tabIndex={6}
                          className="element__input"
                        />
                        <div className="element__error-message">
                          <ErrorMessage name="PROGRAM_ID" />
                        </div>
                      </div>
                    </div>
                    <div className="vehical-owner-info__row">
                      {/* 要/被保險人是否受監護宣告 */}
                      <div className={'element__form-group' + (errors.DECLARED && touched.DECLARED ? ' element__form-group--invalid' : '')}>
                        <div className="element__form-group-title">
                          要/被保險人是否受監護宣告?
                          <span className="element__link" onClick={() => this.props.setGuardianshipStatementModalVisible(true)}>(什麼是監護宣告?)</span>
                        </div>
                        <div className="element__form-group-content" tabIndex={7} data-fieldname="DECLARED">
                          {this.handleCreateDelcareArea(values, errors)}
                        </div>
                        <div className="element__error-message">
                          <ErrorMessage name="DECLARED" />
                          {this.state.isDeclared
                            ? commonService.getCodeMsg(this.props.UICodes, CodeId.W001)
                            : ''}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <FieldArray name="CONTRACTS">
                  {
                    () => (
                      <>
                        {this.handleCreateContractArea(values, errors)}
                      </>
                    )
                  }
                </FieldArray>
                <div className="vehical-owner-info__terms">
                  <div className="element__checkbox-group">
                    <label htmlFor="all-checked-checkbox">
                      <div className="element__checkbox">
                        <Field
                          type="checkbox"
                          name="ALL_CONTRACT_CHECKED"
                          id="all-checked-checkbox"
                          disabled={_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT)}
                          onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                            e.currentTarget.checked
                              ? apiCommonService.fetchSysTime().then((res: any) => {
                                setFieldValue('ALL_CONTRACT_CHECKED_TIME', res);
                              })
                              : setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
                            if (e.currentTarget.checked) {
                              // 重置已展開的條款
                              this.setState({
                                termStatus: commonService.resetTermStatus(this.state.termStatus)
                              });
                            }
                          }}
                        />
                        <div className="element__checkbox-btn" />
                      </div>
                      <span className={'agree-all-terms' + (_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT) ? ' grey' : '')}>我已審閱及同意上述條款</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="insure-process-vehical-owner-info__controls">
                <button
                  type="submit"
                  className="element__button element__button--red"
                  disabled={
                    this.state.isDeclared ||
                    (_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT)) ||
                    !values.ALL_CONTRACT_CHECKED
                  }
                >
                  下一步
                </button>
              </div>
              <FormikFocusError />
            </Form>
          )}
        </Formik>
        {/* Modal - 選擇投保類型 */}
        <SelectInsuranceTypeModal flows={this.state.flows} UICodes={this.props.UICodes} insTypeId={this.props.insTypeId} />
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => ({
  fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGuardianshipStatementModalVisible: (visible: boolean) => dispatch(setGuardianshipStatementModalVisibleAction(visible))
  // setSelectInsuranceTypeModalVisible: (visible: boolean, memberId?:string, nationalityType?:string) => dispatch(setSelectInsuranceTypeModalVisibleAction(visible, memberId, nationalityType))
});

export default connect(mapStateToProps, mapDispatchToProps)(InsureProcessVehicleOwnerInfo);
